// src/components/settings/impact-tab.jsx
// One "Impact" Settings tab for both coaching tools: the Lead Tracker and the
// IMPACT Scorecard. Each sub-tab renders only for users its own feature flag
// allows (owner always; shared users via features.leadTracker /
// features.impactScorecard), so a Client Care user granted just the tracker
// never sees the scorecard, and vice versa.
import React, { useState } from "react";
import { useStateValue } from "../../context/StateProvider";
import {
  isImpactScorecardEnabled,
  isLeadTrackerEnabled,
} from "../../utils/featureFlags";
import ImpactScorecardTab from "./impact-scorecard-tab";
import KnowYourNumbersTab from "./know-your-numbers-tab";
import LeadTrackerTab from "../lead-tracker/LeadTrackerTab";

export default function ImpactTab({ initialSub = "" }) {
  const [{ user }] = useStateValue();
  const showTracker = isLeadTrackerEnabled({ user });
  const showScorecard = isImpactScorecardEnabled({ user });
  const [sub, setSub] = useState(() => {
    if (initialSub === "scorecard" && showScorecard) return "scorecard";
    if (initialSub === "knowYourNumbers" && showScorecard) return "knowYourNumbers";
    if (initialSub === "leadTracker" && showTracker) return "leadTracker";
    return showTracker ? "leadTracker" : "scorecard";
  });
  if (!showTracker && !showScorecard) return null;

  const subs = [
    ...(showTracker ? [{ id: "leadTracker", label: "Lead Tracker" }] : []),
    ...(showScorecard ? [{ id: "scorecard", label: "Scorecard" }] : []),
    // Know Your Numbers shares the scorecard flag — same coaching audience.
    ...(showScorecard
      ? [{ id: "knowYourNumbers", label: "Know Your Numbers" }]
      : []),
  ];
  const active = subs.find((s) => s.id === sub) ? sub : subs[0].id;

  return (
    <div className="space-y-4">
      {subs.length > 1 && (
        <div className="flex border border-slate-300 rounded-lg overflow-hidden text-xs w-fit">
          {subs.map((s) => (
            <button
              key={s.id}
              type="button"
              className={`px-4 py-1.5 font-semibold ${
                active === s.id
                  ? "bg-slate-800 text-white"
                  : "bg-white text-slate-600 hover:bg-slate-50"
              }`}
              onClick={() => setSub(s.id)}
            >
              {s.label}
            </button>
          ))}
        </div>
      )}
      {active === "leadTracker" ? (
        <LeadTrackerTab />
      ) : active === "knowYourNumbers" ? (
        <KnowYourNumbersTab />
      ) : (
        <ImpactScorecardTab />
      )}
    </div>
  );
}
